var _style, _g, _desc, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBreakfast(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 29.9 21.2",
    style: {
      enableBackground: "new 0 0 29.9 21.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#183059;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26.6,1.4c-0.2-0.1-0.4-0.2-0.6-0.3c-0.1,0-0.1-0.1-0.2-0.1c-1.3-0.6-2.7-1-4.2-1c-1.7,0-3.4,0-5.1,0 c-1.7,0-3.4,0-5.1,0C9.8,0,8.3,0.2,6.9,0.8C6.8,0.8,6.7,0.9,6.6,1C6.4,1.1,6.2,1.2,6,1.3C5.7,1.5,5.4,1.6,5.2,1.8 c0.2,0.3,0.4,0.6,0.6,0.8c0.1,0,0.2-0.1,0.3-0.1c0.6-0.3,1.1-0.6,1.6-0.8c1.1-0.4,2.1-0.6,3.2-0.6c0.4,0,0.8,0,1.3,0 c1.1,0.1,2.2,0.3,3.3,0.7c2.3,0.8,3.7,2.5,4,5c0,0.3,0,0.6,0,0.9c0,0.5-0.5,0.9-1.1,0.9s-0.8,0.1-0.8,0.5c0,0.1,0,0.2,0,0.3v10.2 V20H9.9c0.3-0.3,0.6-0.6,0.8-0.8c0.2-0.2,0.4-0.3,0.6-0.4c0.7-0.3,1.4-0.6,2-0.9c0.9-0.4,1.3-1.3,1.2-2.3c-0.1-0.9-0.8-1.7-1.7-1.9 c-0.3-0.1-0.5-0.1-0.8-0.1c0-0.1,0-0.1,0-0.2c0-0.7-0.1-0.8-0.8-0.8c-1.8,0-3.5,0-5.3,0H5.5v-0.4V9.6c0-0.9,0-0.9-0.9-1 c-0.7,0-1.1-0.4-1.1-1.1c0-1.4,0.4-2.6,1.2-3.7c0-0.1,0.1-0.1,0.1-0.2C4.6,3.4,4.3,3.2,4.1,3C4,3.1,3.9,3.2,3.9,3.3 C2.9,4.6,2.5,6,2.5,7.6c0,1.1,0.7,1.9,1.8,2.1c0.1,0,0.2,0.1,0.2,0.2c0,0.9,0,1.8,0,2.8H4.1c-1.2,0-2.3,0-3.5,0 c-0.4,0-0.6,0.2-0.6,0.5c0,1.2-0.1,2.3,0.1,3.5c0.4,2.6,2.6,4.5,5.2,4.5c7.3,0,14.6,0,21.9,0c0.6,0,0.7-0.1,0.7-0.7 c0-3.5,0-6.9,0-10.4V9.7c0.1,0,0.2,0,0.2,0c1-0.1,1.8-0.9,1.8-1.9C29.9,4.9,28.9,2.8,26.6,1.4z M12.1,14.5c0.6-0.1,1.1,0.2,1.3,0.8 c0.2,0.5,0,1.2-0.5,1.5c-0.4,0.2-0.8,0.4-1.2,0.6C11.9,16.4,12,15.4,12.1,14.5z M6.8,19.9C5.9,20,5,20,4.2,19.7 c-1.8-0.5-3.1-2.2-3.2-4.1c0-0.1,0-0.1,0-0.2h1v-1H1v-1h10v1H3v1h8c0,0.3,0,0.5-0.1,0.8C10.6,18.3,8.9,19.8,6.8,19.9z M26.9,19.9 h-8.4V9.5h8.4V19.9z M28.1,8.5c-0.1,0-0.2,0-0.3,0c-0.6,0-1.2,0-1.8,0c-1.9,0-3.7,0-5.6,0c-0.1,0-0.1,0-0.1,0 c0.1-0.4,0.2-0.7,0.2-1.1c0-2.7-1.2-4.8-3.6-6.1c-0.1-0.1-0.2-0.1-0.3-0.2c0,0,0,0,0-0.1c0.5,0,1.1,0,1.6,0h3.1 c0.8,0,1.6,0.1,2.4,0.3c0.9,0.2,1.7,0.5,2.4,0.9s1.3,0.9,1.8,1.6c0.8,1.1,1.2,2.4,1.1,3.7C28.9,8,28.6,8.4,28.1,8.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 1.5,
    className: "st0",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 7.5,
    className: "st0",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 5.5,
    className: "st0",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 4.5,
    className: "st0",
    width: 1,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 22,
    y: 2.5,
    className: "st0",
    width: 0.9,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 4.5,
    className: "st0",
    width: 1,
    height: 0.9
  }))), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(17.000000, 11.016480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(0.694777, 0.913268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip-4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakfast);
export default __webpack_public_path__ + "static/media/breakfast.cde50038.svg";
export { ForwardRef as ReactComponent };